"use client";

import { useEffect } from "react";
import { setCookie } from "utils/cookies";
const SetABTestCookie = ({
  testName,
  variantName
}: {
  testName: string;
  variantName: string;
}) => {
  useEffect(() => {
    setTimeout(() => {
      setCookie(testName, variantName, 30);
    }, 1000);
  }, [testName, variantName]);
  return null;
};
export default SetABTestCookie;